import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { initTenantFromUrl } from "@/lib/tenant";

const urlTenant = initTenantFromUrl();
if (urlTenant) {
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tenant/info`, { headers: { "X-Tenant": urlTenant }, credentials: "include" })
    .then((r) => r.json())
    .then((d) => { if (d.slug !== urlTenant) localStorage.removeItem("tenant_hint"); })
    .catch(() => {});
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
